<template>
<div class="sezione"  style="padding:0 8px;" >


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 36px;">
         <el-breadcrumb-item><span class="yo-text-bold yo-text-m">Mortalità aggiustata</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class=" yo-text-m">EG 22-31 o Peso alla Nascita &#60;= 1.500 gr.</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class=" yo-text-m">Esclusi centri con meno di 10 neonati</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class="yo-text-m">Anno 2022</span></el-breadcrumb-item> 
         <!-- 
         <el-breadcrumb-item>
            <el-select v-model="anno" placeholder="Select"  v-on:change="makeanalisi" size="small" style="width:150px;">
               <el-option label="Anno 2020" :value="2020"></el-option>
               <el-option label="Anno 2019" :value="2019"></el-option>
            </el-select>
         </el-breadcrumb-item>
         -->
      </el-breadcrumb>
   </div>
</div>
</div>
<div style="margin:40px 0;">
   <div  style="position: relative;">

      <div style="display: flex;">
      <img src="../assets/funnel-fdisp-aggiustata-plus10-2022.svg" alt="FUNNEL FDISP GREZZA 2022" style="width:100%;justify-self: flex-end;"/>
      </div>

      <template v-for="(itm, index) in dati"  >
         <div v-if="$centro.profile.row.id==itm.centro" :key="index+'_'+itm.centro" :style="'left: '+xpos(itm.x)+'px;bottom:'+ypos(itm.y)+'px;background: red;position: absolute;width: '+pointw+'px;height: '+pointw+'px;border-radius: 1'+pointw/3+'px;'"></div>
      </template>  

   </div>
   <div class="yo-align-center yo-text-bold yo-text-m">Numero di neonati</div>
</div>



</div>
</template>

<script>

export default {
components: {
   
},
data() {
   return {
      loading:{}
      ,pointw: 24

      ,boxw:1380
      ,boxh:1035

      ,ploth:918
      ,plotw:1235
      ,funnelsx: 64
      ,funnelbottom: 85

      ,maxw: 142
      ,maxh: 45
      ,minh: 0

      ,dati:[

      
      {centro:10017,x:38,y:4.66},
      {centro:10018,x:13,y:10.1},
      {centro:10019,x:38,y:6.76},
      {centro:10021,x:13,y:15.14},
      {centro:10024,x:99,y:16.8},
      {centro:10025,x:64,y:17.6},
      {centro:10028,x:36,y:10.8},
      {centro:10029,x:142,y:9.24},
      {centro:10030,x:27,y:15.02},
      {centro:10031,x:34,y:6.11},
      {centro:10034,x:67,y:2.82},
      {centro:10035,x:76,y:8.38},
      {centro:10036,x:28,y:5.5},
      {centro:10039,x:36,y:20.41},
      {centro:10043,x:44,y:6.6},
      {centro:10044,x:52,y:10.13},
      {centro:10045,x:73,y:5.3},
      {centro:10046,x:63,y:13.03},
      {centro:10047,x:13,y:43.21},
      {centro:10049,x:45,y:9.52},
      {centro:10050,x:29,y:9.92},
      {centro:10051,x:41,y:29.21},
      {centro:10054,x:55,y:2.03},
      {centro:10058,x:31,y:10.41},
      {centro:10060,x:20,y:0},
      {centro:10061,x:29,y:7.16},
      {centro:10063,x:18,y:0},
      {centro:10065,x:12,y:17.27},
      {centro:10066,x:26,y:7.05},
      {centro:10067,x:21,y:13.03},
      {centro:10068,x:27,y:9.66},
      {centro:10069,x:36,y:8.54},
      {centro:10070,x:88,y:15.71},
      {centro:10073,x:36,y:15.24},
      {centro:10075,x:48,y:7.88},
      {centro:10078,x:11,y:13.59},
      {centro:10079,x:30,y:3.04},
      {centro:10081,x:18,y:0},
      {centro:10082,x:40,y:36.15},
      {centro:10083,x:67,y:9.17},
      {centro:10085,x:27,y:6.02},
      {centro:10089,x:63,y:14.35},
      {centro:10091,x:34,y:8.11},
      {centro:10094,x:83,y:16.68},
      {centro:10103,x:40,y:3.61},
      {centro:10104,x:41,y:25.86},
      {centro:10107,x:85,y:22.25},
      {centro:10109,x:47,y:9.52},
      {centro:10110,x:29,y:3.97},
      {centro:10111,x:17,y:16.68},
      {centro:10114,x:86,y:10.51},
      {centro:10116,x:35,y:32.67},
      {centro:10118,x:57,y:12.94},
      {centro:10123,x:27,y:4.01},
      {centro:10124,x:14,y:0},
      {centro:10129,x:62,y:8.63},
      {centro:10134,x:28,y:6.6},
      {centro:10137,x:43,y:5.06},
      {centro:10141,x:24,y:0},
      {centro:10145,x:28,y:14.87},
      {centro:10146,x:39,y:12.94},
      {centro:10150,x:14,y:16.67},
      {centro:10151,x:17,y:15.29},
      {centro:10152,x:34,y:5.77},
      {centro:10153,x:53,y:13.74},
      {centro:10166,x:11,y:17.66}




      ]



   }
},
created () {
},
methods: {
   xpos(x){
      return this.plotw/this.maxw*x + this.funnelsx - this. pointw/2
   },
   ypos(y){
      return this.ploth/(this.maxh-this.minh)*(y-this.minh) + this.funnelbottom - this. pointw/2
   }
}, 
computed:{
}
}
</script>


<style >

</style>
